import { Grid, Select, Textarea, TextInput } from "@mantine/core";
import { WAREHOUSE_TYPE_OPTIONS } from "constants/common/warehouse";
import { FormikProps } from "formik";
import { FC } from "react";

interface WarehouseFormFieldsProps {
  formik: FormikProps<any>;
  isCreateMode?: boolean;
}

const spanHalf = { base: 12, md: 6 };

const WarehouseFormFields: FC<WarehouseFormFieldsProps> = ({
  formik,
  isCreateMode = false,
}) => {
  const getFieldError = (fieldName: string) =>
    formik.touched[fieldName] && formik.errors[fieldName]
      ? (formik.errors[fieldName] as string)
      : null;

  return (
    <Grid>
      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <TextInput
            label="Mã kho"
            placeholder="VD: KHO-001"
            withAsterisk
            {...formik.getFieldProps("code")}
            error={getFieldError("code")}
          />
        </Grid.Col>
      )}

      <Grid.Col span={isCreateMode ? spanHalf : 12}>
        <TextInput
          label="Tên kho"
          placeholder="Nhập tên kho"
          withAsterisk
          {...formik.getFieldProps("name")}
          error={getFieldError("name")}
        />
      </Grid.Col>

      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <Select
            label="Loại kho"
            placeholder="Chọn loại kho"
            withAsterisk
            data={WAREHOUSE_TYPE_OPTIONS}
            value={formik.values.type}
            onChange={(value) => formik.setFieldValue("type", value)}
            onBlur={() => formik.setFieldTouched("type", true)}
            error={getFieldError("type")}
          />
        </Grid.Col>
      )}

      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <Textarea
            label="Mô tả"
            placeholder="Nhập mô tả kho (tuỳ chọn)"
            autosize
            minRows={2}
            {...formik.getFieldProps("description")}
            error={getFieldError("description")}
          />
        </Grid.Col>
      )}
    </Grid>
  );
};

export default WarehouseFormFields;
